import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { SearchSearchProductsQuery } from '@winelivery-org/wl-client-sdk-js/src/models/search/query';
import { useDebounce } from '../../../../../../hooks';
import { useLocalization } from '../../../../../../hooks/useLocalization';
import { searchStoreProducts } from '../../../../../../services/search';

interface Props
  extends Omit<SearchSearchProductsQuery, 'hash' | 'deliveryType'> {
  debounce?: number;
  minimumLength?: number;
  queryType?: 'product' | 'category' | 'subcategory' | 'country' | 'region';
}

function useProductSearch({
  q,
  debounce = 300,
  minimumLength = 2,
  ...rest
}: Props) {
  const { deliveryType, hash } = useLocalization();
  const debouncedQ = useDebounce(q, debounce);

  const queryFilters = useMemo(() => {
    return {
      deliveryType,
      hash,
      q: debouncedQ.trim().toLowerCase(),
      ...rest,
    };
  }, [deliveryType, hash, debouncedQ, rest]);

  return useQuery({
    queryKey: ['product-search', queryFilters],
    queryFn: () =>
      searchStoreProducts({ ...queryFilters, hash: queryFilters.hash || '' }),
    enabled: debouncedQ.trim().length >= minimumLength,
  });
}

export default useProductSearch;
